import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withKeys as _withKeys, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "text-center" }
const _hoisted_3 = {
  class: "btn btn-lg btn-primary",
  ref: "submitButton",
  type: "submit"
}
const _hoisted_4 = { class: "indicator-label" }
const _hoisted_5 = { class: "svg-icon svg-icon-3 ms-2 me-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputsRenderer = _resolveComponent("InputsRenderer")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Form = _resolveComponent("Form")!

  return (_ctx.values && _ctx.inputs)
    ? (_openBlock(), _createBlock(_component_Form, {
        key: 0,
        id: "kt_modal_new_target_form",
        ref: "formRef",
        class: "form",
        "validation-schema": _ctx.validationSchema,
        onSubmit: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('submit'))),
        onInvalidSubmit: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('invalid', $event))),
        onKeydown: _cache[7] || (_cache[7] = _withKeys(_withModifiers(($event: any) => (_ctx.$emit('prevent-enter', $event)), ["prevent"]), ["enter"])),
        autocomplete: "off"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_InputsRenderer, {
              "route-key": _ctx.routeKey,
              id: _ctx.id,
              inputs: _ctx.inputs,
              relationships: _ctx.relationships,
              values: _ctx.innerValues,
              "onUpdate:values": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.innerValues) = $event)),
              onAddNestedRow: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('add-nested-row', $event))),
              onRemoveNestedRow: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('remove-nested-row', $event.fieldName, $event.index))),
              onAddTier: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('add-tier', $event.fieldName, $event.value))),
              onRemoveTier: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('remove-tier', $event.fieldName, $event.index)))
            }, null, 8, ["route-key", "id", "inputs", "relationships", "values"])
          ]),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("button", _hoisted_3, [
              _createElementVNode("span", _hoisted_4, [
                _createTextVNode(" Save "),
                _createElementVNode("span", _hoisted_5, [
                  _createVNode(_component_inline_svg, { src: "icons/duotune/arrows/arr064.svg" })
                ])
              ])
            ], 512)
          ])
        ]),
        _: 1
      }, 8, ["validation-schema"]))
    : _createCommentVNode("", true)
}